import React, { useState, useEffect } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';

const Layout = ({ children }) => {
  // Check screen size and saved preference on initial load
  const [sidebarVisible, setSidebarVisible] = useState(() => {
    // Check if user has a saved preference
    const savedState = localStorage.getItem('sidebarVisible');
    if (savedState !== null) {
      return savedState === 'true';
    }
    // Default to open on desktop, closed on mobile
    return window.innerWidth >= 768;
  });

  // Handle window resize (only for mobile breakpoint)
  useEffect(() => {
    const handleResize = () => {
      // On mobile, always close sidebar
      if (window.innerWidth < 768) {
        setSidebarVisible(false);
        localStorage.setItem('sidebarVisible', 'false');
      }
      // On desktop, restore saved preference or default to open
      else {
        const savedState = localStorage.getItem('sidebarVisible');
        if (savedState === null) {
          setSidebarVisible(true);
          localStorage.setItem('sidebarVisible', 'true');
        }
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => {
    setSidebarVisible((prev) => {
      const newState = !prev;
      // Save user preference
      localStorage.setItem('sidebarVisible', newState);
      return newState;
    });
  };

  return (
    <div className="app-wrapper">
      <Header onToggleSidebar={toggleSidebar} />
      <div className="d-flex">
        {/* Overlay for mobile */}
        {sidebarVisible && window.innerWidth < 768 && (
          <div 
            className="sidebar-overlay"
            onClick={toggleSidebar}
            style={{
              position: 'fixed',
              top: '60px',
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              zIndex: 1040,
              animation: 'fadeIn 0.3s ease'
            }}
          />
        )}
        <Sidebar visible={sidebarVisible} onClose={toggleSidebar} />
        <main className="app-main flex-grow-1">
          {children}
        </main>
      </div>
      <Footer />
    </div>
  );
};

export default Layout;
